export default __webpack_public_path__ + "static/media/pvn-note-size.db33b2b4.webp";